import { WebAsyncLocalStorage } from "@glamcorner/core-cf-lib/lib/client/WebAsyncLocalStorage";

export abstract class BaseStoredItem<StorageType> extends WebAsyncLocalStorage {
  abstract storageKey(): string;

  public async get(): Promise<StorageType | null> {
    return this.retrieveData();
  }

  public async set(data: StorageType) {
    return this.storeData(data);
  }

  public clear(): Promise<void> {
    return this.removeItem(this.buildKey());
  }

  protected async storeData(data: StorageType) {
    await this.setItem(this.buildKey(), JSON.stringify(data));
  }

  protected async retrieveData(): Promise<StorageType | null> {
    let returnValue: StorageType | null = null;
    const retrieved = await this.getItem(this.buildKey());
    if (retrieved) {
      try {
        returnValue = JSON.parse(retrieved);
      } catch (e) {
        console.warn(`StoredItem ${e}`);
        // Must have a wrong value saved
        await this.clear();
      }
    }

    return Promise.resolve(returnValue);
  }

  private buildKey() {
    return `catalogue:${this.storageKey()}`;
  }
}
